// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__PJCA8","footer":"ModalCreateQualiphyProcedure_footer__1H6HX","additionData":"ModalCreateQualiphyProcedure_additionData__GlkW9"};